import { useMinusTransaction } from '@/components/ReportForm/AmountTablesMenu/hooks/useMinusTransaction';
import { useCalcSummary } from '@/features/InvoiceReport/Edit/components/hooks/useCalcSummary';
import {
  ApiErrors,
  ErrorFields,
} from '@/features/InvoiceReport/Edit/components/type';
import { InvoiceTransaction } from '@/features/InvoiceReport/Edit/type';
import { Excises } from 'ap-openapi';
import { useCallback } from 'react';

export const useValidateMinusTotalValue = (
  handleError: (error: ErrorFields | ApiErrors) => boolean,
  invoiceTransactions: InvoiceTransaction[],
  isPermitMinusTransaction: boolean,
  exciseList: Excises[]
) => {
  const { summary } = useCalcSummary(invoiceTransactions, exciseList);
  const errors = useMinusTransaction(isPermitMinusTransaction, summary);

  return useCallback(() => {
    if (invoiceTransactions.length === 0) {
      return true;
    }
    if (errors) {
      handleError({
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        invoiceReport: undefined,
        invoiceTransactions: errors.message,
        invoiceTransactionsAlert: undefined,
        invoiceTransactionsRow: undefined,
      });
      return false;
    } else {
      return true;
    }
  }, [errors, handleError, invoiceTransactions.length]);
};
